import { useQuery } from '@tanstack/react-query';
import type { CursorPage, Project } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useProjects(limit = 50) {
  return useQuery({
    queryKey: ['projects', { limit }],
    queryFn: () => apiGet<CursorPage<Project>>(`/v1/projects?limit=${limit}`),
  });
}
